<cnt-navbar></cnt-navbar>

@if (activity) {
<main class="pt-24 md:pt-28 pb-24 min-h-screen bg-cream">
  <div class="px-[2%]">
    <div class="max-w-4xl mx-auto px-4 md:px-8">

      <!-- Category + title -->
      <div class="flex items-center gap-2 mb-3">
        <span class="w-9 h-9 rounded-full bg-jungle-green/10 inline-flex items-center justify-center shrink-0">
          <span aria-hidden="true" class="material-symbols-outlined text-jungle-green text-xl" style="font-variation-settings: 'FILL' 1;" [cntSymbol]="categoryMeta.icon"></span>
        </span>
        <span class="text-xs uppercase tracking-[0.12em] font-button font-bold text-jungle-green">{{ categoryMeta.label }}</span>
      </div>

      <div class="flex items-start justify-between gap-4 mb-2">
        <h1 class="font-headline font-bold text-dark-text tracking-tight leading-tight text-3xl md:text-4xl">
          {{ activity.getName() || categoryMeta.label }}
        </h1>
        <div class="flex gap-2 shrink-0">
          @if (isOwner) {
            <a [routerLink]="['/activity/edit', activity.id]"
              class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-body font-bold text-dark-text hover:text-trinidad transition-colors">
              <span aria-hidden="true" class="material-symbols-outlined text-lg">edit</span>
              Edit
            </a>
          }
          <button type="button" (click)="toggleFavorite($event)"
            [attr.aria-pressed]="favorited"
            class="inline-flex items-center gap-2 px-3 py-2 text-sm font-body font-bold text-dark-text hover:text-trinidad transition-colors">
            <span aria-hidden="true" class="material-symbols-outlined text-lg"
              [class.text-trinidad]="favorited"
              [style.font-variation-settings]="favorited ? &quot;'FILL' 1&quot; : &quot;'FILL' 0&quot;">favorite</span>
            {{ favorited ? 'Saved' : 'Save' }}
          </button>
        </div>
      </div>

      @if (locationLabel) {
        <p class="text-muted-text font-body mb-6">{{ locationLabel }}</p>
      }

      <!-- Photos -->
      @if (photoUrls.length > 0) {
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-8 rounded-2xl overflow-hidden">
          @for (photo of photoUrls; track $index) {
            <img [src]="photo" [alt]="(activity.getName() || categoryMeta.label) + ' photo ' + ($index + 1)"
              class="w-full h-40 sm:h-48 object-cover" loading="lazy">
          }
        </div>
      }

      <!-- Things to do -->
      @if (thingsToDo) {
        <div class="mb-6">
          <span class="text-trinidad font-label uppercase tracking-[0.14em] text-[0.7rem] font-bold mb-2 block">What's here</span>
          <p class="text-dark-text font-body text-lg">{{ thingsToDo }}</p>
        </div>
      }

      <!-- Description -->
      @if (activity.description) {
        <div class="mb-8 text-muted-text font-body leading-relaxed whitespace-pre-line">{{ activity.description }}</div>
      }

      <!-- Contact -->
      @if (activity.phone || activity.url) {
        <div class="mb-8 bg-white rounded-2xl border border-dark-text/8 p-6 space-y-2">
          @if (activity.phone) {
            <div class="flex items-center gap-3 text-dark-text font-body">
              <span aria-hidden="true" class="material-symbols-outlined text-xl text-jungle-green">call</span>
              {{ activity.phone }}
            </div>
          }
          @if (activity.url) {
            <div class="flex items-center gap-3 text-dark-text font-body">
              <span aria-hidden="true" class="material-symbols-outlined text-xl text-jungle-green">link</span>
              <a [href]="activity.url" target="_blank" rel="noopener" class="text-trinidad hover:underline">{{ activity.url }}</a>
            </div>
          }
        </div>
      }

      <!-- Map -->
      @if (activity.coordinates.lat) {
        <div class="mb-8">
          <span class="text-trinidad font-label uppercase tracking-[0.14em] text-[0.7rem] font-bold mb-3 block">Where it is</span>
          <div class="rounded-2xl overflow-hidden border border-dark-text/10">
            <cnt-mini-map [lat]="activity.coordinates.lat" [lng]="activity.coordinates.lon" [label]="activity.getName() || categoryMeta.label"></cnt-mini-map>
          </div>
        </div>
      }

    </div>
  </div>
</main>
} @else if (notFound) {
<main class="pt-24 md:pt-28 pb-24 min-h-screen bg-cream flex items-center justify-center px-4">
  <div class="text-center max-w-md">
    <span class="material-symbols-outlined text-5xl text-muted-text mb-3" aria-hidden="true">search_off</span>
    <h1 class="font-headline font-bold text-2xl text-dark-text mb-2">Point of interest not found</h1>
    <p class="font-body text-muted-text mb-6">This point of interest may have been removed, or the link is incorrect.</p>
    <a routerLink="/"
      class="inline-flex items-center justify-center px-6 py-3 rounded-full bg-trinidad text-white text-xs uppercase tracking-[0.12em] font-button font-bold no-underline hover:opacity-95">
      Back home
    </a>
  </div>
</main>
} @else {
<main class="pt-24 md:pt-28 pb-24 min-h-screen bg-cream flex items-center justify-center px-4">
  <div class="flex flex-col items-center gap-3 text-muted-text">
    <span class="material-symbols-outlined text-4xl animate-spin" aria-hidden="true">progress_activity</span>
    <span class="text-xs uppercase tracking-[0.12em] font-button font-bold">Loading…</span>
  </div>
</main>
}

<curbnturf-footer></curbnturf-footer>
